import React, { useRef, useState } from "react";
import styles from "./AddStaff.module.css";
import {
  Dropdown,
  InputField,
  Modal,
  PhoneInput,
  TextComponent,
} from "../../../../components";
import { RiDeleteBin6Line } from "react-icons/ri";
import imagePlaceHolder from "../../../../assets/images/dummy.png";
import { PiSealCheck } from "react-icons/pi";
import { FaSquareCheck } from "react-icons/fa6";
import { FaRegSquare, FaSquare } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
const AddStaff = ({ AddStaffModal, setAddStaffModal }) => {
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [staffRole, setStaffRole] = useState("");
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);
  const [permissionArr, setPermissionArr] = useState([
    {
      name: "action_for_immobilizer",
      is_access: 0,
    },
    {
      name: "add_asset",
      is_access: 0,
    },
    {
      name: "group_immobilizer",
      is_access: 0,
    },
    {
      name: "temporary_access",
      is_access: 0,
    },
    {
      name: "sell_through",
      is_access: 0,
    },
    {
      name: "reports",
      is_access: 0,
    },
    {
      name: "pair_unpair_device",
      is_access: 0,
    },
    {
      name: "staff_creation",
      is_access: 0,
    },
    {
      name: "lot_name",
      is_access: 0,
    },
  ]);

  const onUpdatePermissions = (item, index) => {
    const updatedArr = [...permissionArr];
    updatedArr[index] = {
      ...item,
      is_access: item.is_access === 1 ? 0 : 1,
    };
    setPermissionArr(updatedArr);
  };

  const onCreateStaff = () => {
    let userData = {
      firstName,
      lastName,
      email,
      contactNo,
      staffRole,
      permissionArr,
    };
    const allPermissionsOff = permissionArr.every(
      (item) => item.is_access === 0,
    );
    if (
      !firstName ||
      !lastName ||
      !email ||
      !contactNo ||
      !staffRole ||
      permissionArr?.length == 0
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are required",
        }),
      );
    } else if (allPermissionsOff) {
      dispatch(
        showAlert({
          type: "Error",
          message: "At least one permission must be enabled",
        }),
      );
    } else {
      dispatch(AuthMiddleware.createStaff(userData)).then(() => {
        setAddStaffModal(false);
        setIsSuccessFulModal(true);
      });
    }
  };

  return (
    <div>
      <Modal
        width={"600px"}
        open={AddStaffModal}
        onCancel={() => {
          setAddStaffModal(false);
        }}
        twoButton
        okBtnTitle={"Save Information"}
        cancelBtnTitle={"Go Back"}
        onClickCancelButton={() => {
          setAddStaffModal(false);
        }}
        onClickOkButton={onCreateStaff}
      >
        <div className={styles.mainCont}>
          <TextComponent
            text={"Add Staff/Owner"}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--dashboard_tabs-font-size)",
            }}
          />
          <TextComponent
            text={"Add Profile Information"}
            style={{ color: "var(--light-text)" }}
          />

          <div className={styles.twoInput}>
            <InputField
              className={styles.input}
              label={"First Name"}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder={"Write here..."}
            />
            <InputField
              className={styles.input}
              label={"Last Name"}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder={"Write here..."}
            />
          </div>

          <div className={styles.twoInput}>
            <InputField
              className={styles.input}
              label={"Email"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={"Write here..."}
              type="email"
            />
            <PhoneInput
              label={"Contact number"}
              placeholder={"(301) 580-7410"}
              className={styles.input}
              value={contactNo}
              onChange={setContactNo}
              type="number"
            />
          </div>
          <InputField
            label={"Role"}
            value={staffRole}
            onChange={(e) => setStaffRole(e.target.value)}
            placeholder={"Write here..."}
          />
          <TextComponent
            text={"Permissions"}
            className={styles.permissionText}
          />

          {permissionArr?.map((item, index) => (
            <div
              className={styles.perArr}
              onClick={() => onUpdatePermissions(item, index)}
            >
              {item?.is_access == 1 ? (
                <FaSquareCheck color="var(--secondary-color)" size={18} />
              ) : (
                <FaRegSquare color="var(--secondary-color)" size={18} />
              )}
              <TextComponent
                className={styles.perText}
                text={
                  item?.name == "action_for_immobilizer"
                    ? "Action For Immobilizer"
                    : item?.name == "add_asset"
                      ? "Add Vehicle"
                      : item?.name == "group_immobilizer"
                        ? "Lot lockdown control"
                        : item?.name == "temporary_access"
                          ? "Temporary Access"
                          : item?.name == "sell_through"
                            ? "Sell Through"
                            : item?.name == "reports"
                              ? "Reports"
                              : item?.name == "staff_creation"
                                ? "Staff Creation"
                                : item?.name == "pair_unpair_device"
                                  ? "Pair/Unpair Device"
                                  : item?.name == "lot_name"
                                    ? "Lot Name"
                                    : ""
                }
              />
            </div>
          ))}
        </div>
      </Modal>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Changes saved"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => setIsSuccessFulModal(false)}
      ></Modal>
    </div>
  );
};

export default AddStaff;
